<div class="dropdown" tabindex="0">
  <div class="dropdown-select-toggle" (click)="toggle()" #dropdownToggle>
    <div class="dropdown-select-input">
      <ng-container *ngIf="!getSelectedOptions().length">
        <span class="dropdown-select-placeholder" *ngIf="hasPlaceholder()">{{ placeholder }}</span>
        <span *ngIf="!hasPlaceholder()">&nbsp;</span>
      </ng-container>

      <ng-container *ngIf="getSelectedOptions().length">
        <ng-container *ngFor="let html of selectedOptionsHtml">
          <span [innerHTML]="html" [ngClass]="{'me-1':multiple, 'badge':multiple && showBadge}"></span>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <ul class="dropdown-select my-1" [hidden]="!isShown()" [ngClass]="{show:isShown()}" #dropdownSelect>
    <div *ngIf="searchTerm" class="input-group form-search-term">
      <input type="text" class="form-control" [ngModel]="searchTerm">
      <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="clearSearch()"><i
        class="bi bi-x-lg"></i></button>
    </div>
    @if (selectAll) {
      <div class="text-center my-2 px-3">
        <button (click)="onSelectAll()" class="btn btn-sm btn-primary fw-bold w-100" type="button">SELECT / UNSELECT
          ALL
        </button>
      </div>
    }

    <ng-content></ng-content>

    <div *ngIf="hasNoOptions()" class="px-2 fw-bold">
      No results
    </div>
  </ul>
</div>
